<!--
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
-->
<app-dialog-banner [text]="config.title" [dialogRef]="dialogRef"></app-dialog-banner>
<mat-dialog-content style="padding: 0 8px 8px; margin: 0;" [style.width.px]="width">
  <app-table [config]="config" [drilldown]="false"></app-table>
</mat-dialog-content>
